import { EventGuestBreakdown } from 'legacy/search/types';

export enum StepsIds {
  DefaultOptions = 'defaultOptions',
  SubmitRefundStep = 'submitRefundStep'
}

export type GoToStepFn = (step: StepsIds) => void;

export type StepProps = {
  goToStep: GoToStepFn;
  ticket: EventGuestBreakdown;
  onClose: () => void;
  onViewDetails: () => void;
  refetchGuestList: () => void;
  eventId: string;
  isOrganizer: boolean;
};
